import * as React from 'react'
import NextNProgress from 'nextjs-progressbar'

export default function PageProgress() {
    return <NextNProgress />
}
